interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "KGS";
};

const KGS: Currency = Object.freeze({
  "displayName": "Kyrgystani Som",
  "numericCode": 417,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "KGS",
  "symbol": "с"
});

export { KGS };
